import React, {FC} from 'react';

import {MessageModel} from '../../../../../../libs/shared/core/src/models/api/messageModel';
import {SeenPill} from '../../../../../../libs/shared/ui/src/components/pill/seenPill';
import {PopoverCoordinator} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {SeenDropdownContainer} from './seenDropdownContainer';

/*
 * Props.
 */

export interface MessageViewerSeenProps {
  message: MessageModel;
  hasSmallPill?: boolean;
}

/*
 * Component.
 */

export const MessageViewerSeen: FC<MessageViewerSeenProps> = (props) => {
  const {message} = props;

  if (!message.isSeen) {
    return null;
  }

  return (
    <PopoverCoordinator
      renderButton={() => renderSeenButton(Boolean(props.hasSmallPill))}
      renderModal={(modalProps) => <SeenDropdownContainer {...modalProps} message={message} />}
      shouldHoverWhenOpen
    />
  );
};

/*
 * Button.
 */

function renderSeenButton(hasSmallPill: boolean) {
  return <SeenPill size={hasSmallPill ? VisualSizesEnum.SMALL : VisualSizesEnum.MEDIUM} />;
}
